import { render, staticRenderFns } from "./CalendarAddRemoveButton.vue?vue&type=template&id=38c8d1d7"
import script from "./CalendarAddRemoveButton.vue?vue&type=script&lang=js"
export * from "./CalendarAddRemoveButton.vue?vue&type=script&lang=js"
import style0 from "./CalendarAddRemoveButton.vue?vue&type=style&index=0&id=38c8d1d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports